import React from 'react'

export const Logo = ({ className }) => {
  return (
    <svg
      className={className}
      width="135"
      height="32"
      viewBox="0 0 135 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.04618 9.47341H0V4.62695H17.3468V9.47341H11.3007V27.3746H6.04436V9.47341H6.04618Z"
        fill="#353535"
      />
      <path
        d="M20.0913 22.2142C19.0501 20.402 18.5312 18.3302 18.5312 16.0008C18.5312 13.6716 19.0519 11.5731 20.0913 9.76968C21.1309 7.96814 22.5661 6.55481 24.3954 5.53319C26.2231 4.51172 28.3323 4 30.7198 4C33.1073 4 35.2486 4.51172 37.078 5.53319C38.9074 6.55481 40.3409 7.96814 41.3821 9.76968C42.4217 11.5712 42.9423 13.6483 42.9423 16.0008C42.9423 18.3535 42.4217 20.402 41.3821 22.2142C40.3409 24.0265 38.9074 25.4452 37.078 26.4668C35.2486 27.4883 33.1303 28 30.7198 28C28.3092 28 26.2231 27.4883 24.3954 26.4668C22.5661 25.4452 21.1309 24.0265 20.0913 22.2142ZM36.602 19.5611C37.1707 18.5288 37.456 17.3409 37.456 16.0008C37.456 14.6609 37.1707 13.4748 36.602 12.4407C36.0314 11.4084 35.2433 10.5997 34.2359 10.0184C33.2285 9.43691 32.0571 9.14526 30.7198 9.14526C29.3825 9.14526 28.245 9.43691 27.2376 10.0184C26.2302 10.6015 25.435 11.4084 24.8555 12.4407C24.2742 13.4748 23.9853 14.6609 23.9853 16.0008C23.9853 17.3409 24.276 18.5288 24.8555 19.5611C25.435 20.5951 26.2302 21.402 27.2376 21.9834C28.245 22.5667 29.4057 22.8566 30.7198 22.8566C32.0339 22.8566 33.2267 22.5649 34.2359 21.9834C35.2433 21.402 36.0314 20.5934 36.602 19.5611Z"
        fill="#353535"
      />
      <path
        d="M82.8942 4.09766H83.256L95.2147 27.3713H89.3986L87.9204 24.2387H78.13L76.5538 27.3713H70.9355L82.8942 4.09766ZM85.8503 19.8895L83.0243 13.9893L80.2322 19.8895H85.8503Z"
        fill="#353535"
      />
      <path
        d="M105.924 9.47341H96.6591V4.62695H114.4V4.99018L104.97 22.5281H114.53V27.3746H96.5254V27.0114L105.922 9.47341H105.924Z"
        fill="#353535"
      />
      <path
        d="M126.389 9.47341H117.125V4.62695H134.866V4.99018L125.437 22.5281H134.996V27.3746H116.992V27.0114L126.388 9.47341H126.389Z"
        fill="#353535"
      />
      <path
        d="M57.7205 16.2727L45.8047 4.31836V27.3558H50.6188V15.9793L54.9996 20.3749L57.7205 17.6448L60.4396 20.3749L64.8204 15.9793V27.3558H69.6345V4.31836L57.7205 16.2727Z"
        fill="#2264DC"
      />
    </svg>
  )
}
export default Logo
